export interface ConfirmationStatusModel {
  confirmationStatusId: ConfirmationStatusEnum;
  description: string;
}

export enum ConfirmationStatusEnum {
  Unconfirmed = 0,
  Available = 1,
  Unavailable = 2,
}
